import { ReactElement } from 'react';
import { IsLoginChecker } from '../../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import { MyCommentContainer } from '../../../domain/comment/my/[[...pathParams]]/container/MyCommentContainer';
import { CommonMobileHeaderType } from '../../../header/constants';
function MyCommentPage() {
  return <IsLoginChecker>
      <MyCommentContainer />
      <TrackPageViewContainer trackObj={{
      section: '댓글',
      page: '댓글내역_메인',
      actionType: 'Pageview',
      actionName: '댓글내역_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </IsLoginChecker>;
}
MyCommentPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('mycomment_title')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.ThreeDepth
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default MyCommentPage;